
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import delphiLogo from '@/assets/delphi-logo.png.asset.json';

const Footer = () => {
  return (
    <footer className="bg-delphi-dark border-t border-delphi-gray/20 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Brief */}
          <div className="col-span-1 md:col-span-2 space-y-4">
            <Link to="/">
              <img 
                src={delphiLogo.url} 
                alt="DEL(PHI) Technologies Logo" 
                className="h-10 w-auto" 
              />
            </Link>
            <p className="text-sm text-delphi-light/60 max-w-md">
              A quantitative hedge fund strategically balancing cutting-edge trading innovation with theoretical research to push the boundaries of scientific understanding.
            </p>
          </div>
          
          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-medium text-delphi-light">Quick Links</h4>
            <ul className="space-y-2">
              {/* Temporarily hidden: Trading Philosophy link */}
              <li>
                <Link to="/research" className="text-xs text-delphi-light/60 hover:text-delphi-red transition-colors">
                  Research
                </Link>
              </li>
              <li>
                <Link to="/performance" className="text-xs text-delphi-light/60 hover:text-delphi-red transition-colors">
                  Performance Record
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-xs text-delphi-light/60 hover:text-delphi-red transition-colors">
                  Managing Partners
                </Link>
              </li>
              {/* Temporarily hidden: What's Next? link */}
              <li>
                <Link to="/contact" className="text-xs text-delphi-light/60 hover:text-delphi-red transition-colors">
                  See for Yourself
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact & Legal */}
          <div className="space-y-4">
            <h4 className="text-sm font-medium text-delphi-light">Contact</h4>
            <a href="mailto:contact@del-phi.com" className="flex items-center text-delphi-light/60 hover:text-delphi-red transition-colors gap-2 text-xs">
              <Mail size={14} />
              <span>contact@del-phi.com</span>
            </a>
            
            {/* New Address Section */}
            <div className="flex items-center text-delphi-light/60 hover:text-delphi-red transition-colors gap-2 text-xs mt-2">
              <MapPin size={14} />
              <address className="not-italic">
                300 Delaware Ave<br />
                Ste 210 #664<br />
                Wilmington, DE 19801
              </address>
            </div>
            
            <Link to="/contact" className="inline-block mt-2 text-xs bg-delphi-gray/20 px-4 py-2 rounded hover:bg-delphi-gray/30 transition-colors">
              Request Information
            </Link>
            
            <div className="pt-4 mt-4 border-t border-delphi-gray/20">
              <h4 className="text-sm font-medium text-delphi-light mb-2">Legal</h4>
              <p className="text-xs text-delphi-light/40">
                Information found on this site is intended only for Accredited, Qualified, or Institutional Investors as defined by the S.E.C.
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-delphi-gray/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-delphi-light/40">
            © {new Date().getFullYear()} DEL(PHI) MANAGEMENT DOMESTIC LLC
          </p>
          <div className="mt-4 md:mt-0">
            <img 
              src="/lovable-uploads/e1cd42cf-2e4f-4e13-a24f-b5b6123e6297.png" 
              alt="DEL(PHI) Mathematical Expression" 
              className="h-6" 
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
